export const AdoBoxIcon = ({
  width,
  height,
  className,
  label,
}: {
  width?: number;
  height?: number;
  className?: string;
  label?: string;
}) => (
  <svg
    width={width ?? '20'}
    height={height ?? '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role={label == null ? undefined : 'img'}
    aria-label={label}
    aria-hidden={label == null ? true : undefined}
    className={className}
  >
    {label != null && <title>{label}</title>}
    <path
      d="M2 6C2 3.79086 3.79086 2 6 2H14C16.2091 2 18 3.79086 18 6V14C18 16.2091 16.2091 18 14 18H6C3.79086 18 2 16.2091 2 14V6Z"
      fill="#0078D7"
    />
    <g transform="translate(4.5 4.5) scale(0.4583)">
      <path
        d="M0 8.877L2.247 5.91l8.405-3.416V.022l7.37 5.393L2.966 8.338v8.225L0 15.707zm24-4.45v14.651l-5.753 4.9-9.303-3.057v3.056l-5.978-7.416 15.057 1.798V5.415z"
        fill="white"
      />
    </g>
  </svg>
);
